import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _DModal, _DModal_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
let cached = esc(require('@glimmer/tracking')).cached;
import { concat } from "@ember/helper";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import didInsert from "@ember/render-modifiers/modifiers/did-insert";
import willDestroy from "@ember/render-modifiers/modifiers/will-destroy";
import { service } from "@ember/service";
import { modifier as modifierFn } from "ember-modifier";
import { and, not, or } from "truth-helpers";
import ConditionalInElement from "discourse/components/conditional-in-element";
import DButton from "discourse/components/d-button";
import concatClass from "discourse/helpers/concat-class";
import element from "discourse/helpers/element";
import { disableBodyScroll, enableBodyScroll } from "discourse/lib/body-scroll-lock";
import { getMaxAnimationTimeMs } from "discourse/lib/swipe-events";
import swipe from "discourse/modifiers/swipe";
import trapTab from "discourse/modifiers/trap-tab";
import { bind } from "discourse-common/utils/decorators";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
import esc from "../../../../../../../../node_modules/@embroider/macros/src/addon/es-compat2";
export const CLOSE_INITIATED_BY_BUTTON = "initiatedByCloseButton";
export const CLOSE_INITIATED_BY_ESC = "initiatedByESC";
export const CLOSE_INITIATED_BY_CLICK_OUTSIDE = "initiatedByClickOut";
export const CLOSE_INITIATED_BY_MODAL_SHOW = "initiatedByModalShow";
export const CLOSE_INITIATED_BY_SWIPE_DOWN = "initiatedBySwipeDown";
const FLASH_TYPES = ["success", "error", "warning", "info"];
const SWIPE_VELOCITY_THRESHOLD = 0.4;
let DModal = (_class = (_DModal_brand = /*#__PURE__*/new WeakSet(), (_DModal = class DModal extends Component {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _DModal_brand);
    _initializerDefineProperty(this, "modal", _descriptor, this);
    _initializerDefineProperty(this, "site", _descriptor2, this);
    _initializerDefineProperty(this, "appEvents", _descriptor3, this);
    _initializerDefineProperty(this, "wrapperElement", _descriptor4, this);
    _initializerDefineProperty(this, "animating", _descriptor5, this);
    _defineProperty(this, "registerModalContainer", modifierFn(el1 => {
      this.modalContainer = el1;
    }));
    _defineProperty(this, "setupModalBody", modifierFn(el1 => {
      if (!this.site.mobileView) {
        return;
      }
      disableBodyScroll(el1);
      return () => {
        enableBodyScroll(el1);
      };
    }));
  }
  async setupModal(el1) {
    document.documentElement.addEventListener("keydown", this.handleDocumentKeydown);
    this.appEvents.on("keyboard-visibility-change", this.handleKeyboardVisibilityChange);
    if (this.site.mobileView) {
      this.animating = true;
      await el1.animate([{
        transform: "translateY(100%)"
      }, {
        transform: "translateY(0)"
      }], {
        duration: getMaxAnimationTimeMs(),
        easing: "ease",
        fill: "forwards"
      }).finished;
      this.animating = false;
    }
    this.wrapperElement = el1;
  }
  cleanupModal() {
    document.documentElement.removeEventListener("keydown", this.handleDocumentKeydown);
    this.appEvents.off("keyboard-visibility-change", this.handleKeyboardVisibilityChange);
  }
  get dismissable() {
    if (!this.args.closeModal) {
      return false;
    } else if ("dismissable" in this.args) {
      return this.args.dismissable;
    } else {
      return true;
    }
  }
  shouldTriggerClickOnEnter(event1) {
    if (this.args.submitOnEnter === false) {
      return false;
    }
    // skip when in a form or a textarea element
    if (event1.target.closest("form") || document.activeElement?.nodeName === "TEXTAREA") {
      return false;
    }
    return true;
  }
  async handleSwipe(swipeEvent1) {
    if (this.animating) {
      return;
    }
    if (swipeEvent1.deltaY >= 0) {
      return await _assertClassBrand(_DModal_brand, this, _animateWrapperPosition).call(this, swipeEvent1.deltaY);
    }
  }
  async handleSwipeEnded(swipeEvent1) {
    if (this.animating) {
      // if the modal is animating we don't want to risk resetting the position
      // as the user releases the swipe at the same time
      return;
    }
    if (swipeEvent1.goingUp() || swipeEvent1.velocityY < SWIPE_VELOCITY_THRESHOLD) {
      return await _assertClassBrand(_DModal_brand, this, _animateWrapperPosition).call(this, 0);
    }
    this.modalContainer.style.transform = `translateY(${swipeEvent1.deltaY}px)`;
    this.closeModal(CLOSE_INITIATED_BY_SWIPE_DOWN);
  }
  handleWrapperClick(e1) {
    if (e1.button !== 0) {
      return; // Non-default mouse button
    }
    if (!this.dismissable) {
      return;
    }
    return this.closeModal(CLOSE_INITIATED_BY_CLICK_OUTSIDE);
  }
  async closeModal(initiatedBy1) {
    if (!this.args.closeModal) {
      return;
    }
    if (this.site.mobileView) {
      this.animating = true;
      _assertClassBrand(_DModal_brand, this, _animateBackdropOpacity).call(this, window.innerHeight);
      await _assertClassBrand(_DModal_brand, this, _animateWrapperPosition).call(this, this.modalContainer.clientHeight);
      this.animating = false;
    }
    this.args.closeModal({
      initiatedBy: initiatedBy1
    });
  }
  handleDocumentKeydown(event1) {
    if (this.args.hidden) {
      return;
    }
    if (event1.key === "Escape" && this.dismissable) {
      event1.stopPropagation();
      this.closeModal(CLOSE_INITIATED_BY_ESC);
    }
    if (event1.key === "Enter" && this.shouldTriggerClickOnEnter(event1)) {
      this.wrapperElement.querySelector(".d-modal__footer .btn-primary")?.click();
      event1.preventDefault();
    }
  }
  handleCloseButton() {
    this.closeModal(CLOSE_INITIATED_BY_BUTTON);
  }
  validateFlashType(type1) {
    if (type1 && !FLASH_TYPES.includes(type1)) {
      throw `@flashType must be one of ${FLASH_TYPES.join(", ")}`;
    }
  }
  // Could be optimised to remove classic component once RFC389 is implemented
  // https://rfcs.emberjs.com/id/0389-dynamic-tag-names
  get dynamicElement() {
    const tagName1 = this.args.tagName || "div";
    if (!["div", "form"].includes(tagName1)) {
      throw `@tagName must be form or div`;
    }
    return element(tagName1);
  }
  handleKeyboardVisibilityChange(visible1) {
    if (visible1) {
      window.scrollTo(0, 0);
    }
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    {{! template-lint-disable no-invalid-interactive }}

    <ConditionalInElement
      @element={{this.modal.containerElement}}
      @inline={{@inline}}
      @append={{true}}
    >
      <this.dynamicElement
        class={{concatClass
          "modal"
          "d-modal"
          (if @inline "-inline")
          (if this.animating "is-animating")
        }}
        data-keyboard="false"
        aria-modal="true"
        role="dialog"
        aria-labelledby={{if @title "discourse-modal-title"}}
        ...attributes
        {{didInsert this.setupModal}}
        {{willDestroy this.cleanupModal}}
        {{trapTab preventScroll=false}}
      >
        <div class="d-modal__container" {{this.registerModalContainer}}>
          {{yield to="aboveHeader"}}

          {{#if
            (and
              (not @hideHeader)
              (or
                this.dismissable
                @title
                (has-block "headerBelowTitle")
                (has-block "headerAboveTitle")
              )
            )
          }}
            <div
              class={{concatClass "d-modal__header" @headerClass}}
              {{swipe
                onDidSwipe=this.handleSwipe
                onDidEndSwipe=this.handleSwipeEnded
                enabled=this.dismissable
              }}
            >
              {{yield to="headerAboveTitle"}}

              {{#if
                (and
                  this.site.mobileView
                  this.dismissable
                  (has-block "headerPrimaryAction")
                )
              }}
                <div class="d-modal__dismiss-action">
                  <DButton
                    @label="cancel"
                    @action={{this.handleCloseButton}}
                    @title="modal.close"
                    class="btn-transparent btn-primary d-modal__dismiss-action-button"
                  />
                </div>
              {{/if}}

              {{#if @title}}
                <div class="d-modal__title">
                  <h1
                    id="discourse-modal-title"
                    class="d-modal__title-text"
                  >{{@title}}</h1>

                  {{#if @subtitle}}
                    <p class="d-modal__subtitle-text">{{@subtitle}}</p>
                  {{/if}}

                  {{yield to="belowModalTitle"}}
                </div>
              {{/if}}
              {{yield to="headerBelowTitle"}}

              {{#if
                (and this.site.mobileView (has-block "headerPrimaryAction"))
              }}
                <div class="d-modal__primary-action">
                  {{yield to="headerPrimaryAction"}}
                </div>
              {{else if this.dismissable}}
                <DButton
                  @icon="times"
                  @action={{this.handleCloseButton}}
                  @title="modal.close"
                  class="btn-transparent modal-close"
                />
              {{/if}}
            </div>
          {{/if}}

          {{yield to="belowHeader"}}

          {{this.validateFlashType @flashType}}
          {{#if @flash}}
            <div
              id="modal-alert"
              role="alert"
              class={{concatClass
                "alert"
                (if @flashType (concat "alert-" @flashType))
              }}
            >
              {{~@flash~}}
            </div>
          {{/if}}

          <div
            class={{concatClass "d-modal__body" @bodyClass}}
            {{this.setupModalBody}}
            tabindex="-1"
          >
            {{#if (has-block "body")}}
              {{yield to="body"}}
            {{else}}
              {{yield}}
            {{/if}}
          </div>

          {{#if (has-block "footer")}}
            <div class="d-modal__footer">
              {{yield to="footer"}}
            </div>
          {{/if}}

          {{yield to="belowFooter"}}
        </div>
      </this.dynamicElement>
      {{#unless @inline}}
        <div
          class="d-modal__backdrop"
          {{swipe
            onDidSwipe=this.handleSwipe
            onDidEndSwipe=this.handleSwipeEnded
            enabled=this.dismissable
          }}
          {{on "click" this.handleWrapperClick}}
        ></div>
      {{/unless}}
    </ConditionalInElement>
  
*/
{
  "id": "UrLgteKj",
  "block": "[[[1,\"\\n\"],[1,\"\\n    \"],[8,[32,0],null,[[\"@element\",\"@inline\",\"@append\"],[[30,0,[\"modal\",\"containerElement\"]],[30,1],true]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,0,[\"dynamicElement\"]],[[16,0,[28,[32,1],[\"modal\",\"d-modal\",[52,[30,1],\"-inline\"],[52,[30,0,[\"animating\"]],\"is-animating\"]],null]],[24,\"data-keyboard\",\"false\"],[24,\"aria-modal\",\"true\"],[24,\"role\",\"dialog\"],[16,\"aria-labelledby\",[52,[30,2],\"discourse-modal-title\"]],[17,3],[4,[32,2],[[30,0,[\"setupModal\"]]],null],[4,[32,3],[[30,0,[\"cleanupModal\"]]],null],[4,[32,4],null,[[\"preventScroll\"],[false]]]],null,[[\"default\"],[[[[1,\"\\n        \"],[11,0],[24,0,\"d-modal__container\"],[4,[30,0,[\"registerModalContainer\"]],null,null],[12],[1,\"\\n          \"],[18,10,null],[1,\"\\n\\n\"],[41,[28,[32,5],[[28,[32,6],[[30,4]],null],[28,[32,7],[[30,0,[\"dismissable\"]],[30,2],[48,[30,11]],[48,[30,12]]],null]],null],[[[1,\"            \"],[11,0],[16,0,[28,[32,1],[\"d-modal__header\",[30,5]],null]],[4,[32,8],null,[[\"onDidSwipe\",\"onDidEndSwipe\",\"enabled\"],[[30,0,[\"handleSwipe\"]],[30,0,[\"handleSwipeEnded\"]],[30,0,[\"dismissable\"]]]]],[12],[1,\"\\n              \"],[18,12,null],[1,\"\\n\\n\"],[41,[28,[32,5],[[30,0,[\"site\",\"mobileView\"]],[30,0,[\"dismissable\"]],[48,[30,13]]],null],[[[1,\"                \"],[10,0],[14,0,\"d-modal__dismiss-action\"],[12],[1,\"\\n                  \"],[8,[32,9],[[24,0,\"btn-transparent btn-primary d-modal__dismiss-action-button\"]],[[\"@label\",\"@action\",\"@title\"],[\"cancel\",[30,0,[\"handleCloseButton\"]],\"modal.close\"]],null],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,2],[[[1,\"                \"],[10,0],[14,0,\"d-modal__title\"],[12],[1,\"\\n                  \"],[10,\"h1\"],[14,1,\"discourse-modal-title\"],[14,0,\"d-modal__title-text\"],[12],[1,[30,2]],[13],[1,\"\\n\\n\"],[41,[30,6],[[[1,\"                    \"],[10,2],[14,0,\"d-modal__subtitle-text\"],[12],[1,[30,6]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n                  \"],[18,14,null],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],null],[1,\"              \"],[18,11,null],[1,\"\\n\\n\"],[41,[28,[32,5],[[30,0,[\"site\",\"mobileView\"]],[48,[30,13]]],null],[[[1,\"                \"],[10,0],[14,0,\"d-modal__primary-action\"],[12],[1,\"\\n                  \"],[18,13,null],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"dismissable\"]],[[[1,\"                \"],[8,[32,9],[[24,0,\"btn-transparent modal-close\"]],[[\"@icon\",\"@action\",\"@title\"],[\"times\",[30,0,[\"handleCloseButton\"]],\"modal.close\"]],null],[1,\"\\n              \"]],[]],null]],[]]],[1,\"            \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n          \"],[18,15,null],[1,\"\\n\\n          \"],[1,[28,[30,0,[\"validateFlashType\"]],[[30,7]],null]],[1,\"\\n\"],[41,[30,8],[[[1,\"            \"],[10,0],[14,1,\"modal-alert\"],[14,\"role\",\"alert\"],[15,0,[28,[32,1],[\"alert\",[52,[30,7],[28,[32,10],[\"alert-\",[30,7]],null]]],null]],[12],[1,[30,8]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n          \"],[11,0],[16,0,[28,[32,1],[\"d-modal__body\",[30,9]],null]],[24,\"tabindex\",\"-1\"],[4,[30,0,[\"setupModalBody\"]],null,null],[12],[1,\"\\n\"],[41,[48,[30,16]],[[[1,\"              \"],[18,16,null],[1,\"\\n\"]],[]],[[[1,\"              \"],[18,17,null],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n\\n\"],[41,[48,[30,18]],[[[1,\"            \"],[10,0],[14,0,\"d-modal__footer\"],[12],[1,\"\\n              \"],[18,18,null],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n          \"],[18,19,null],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"],[41,[51,[30,1]],[[[1,\"        \"],[11,0],[24,0,\"d-modal__backdrop\"],[4,[32,8],null,[[\"onDidSwipe\",\"onDidEndSwipe\",\"enabled\"],[[30,0,[\"handleSwipe\"]],[30,0,[\"handleSwipeEnded\"]],[30,0,[\"dismissable\"]]]]],[4,[32,11],[\"click\",[30,0,[\"handleWrapperClick\"]]],null],[12],[13],[1,\"\\n\"]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n  \"]],[\"@inline\",\"@title\",\"&attrs\",\"@hideHeader\",\"@headerClass\",\"@subtitle\",\"@flashType\",\"@flash\",\"@bodyClass\",\"&aboveHeader\",\"&headerBelowTitle\",\"&headerAboveTitle\",\"&headerPrimaryAction\",\"&belowModalTitle\",\"&belowHeader\",\"&body\",\"&default\",\"&footer\",\"&belowFooter\"],false,[\"if\",\"yield\",\"has-block\",\"unless\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/d-modal.js",
  "scope": () => [ConditionalInElement, concatClass, didInsert, willDestroy, trapTab, and, not, or, swipe, DButton, concat, on],
  "isStrictMode": true
}), _DModal), _DModal)), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "modal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "appEvents", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "wrapperElement", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "animating", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setupModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setupModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cleanupModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "cleanupModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSwipe", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSwipe"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSwipeEnded", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSwipeEnded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleWrapperClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleWrapperClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleDocumentKeydown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleDocumentKeydown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleCloseButton", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleCloseButton"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validateFlashType", [action], Object.getOwnPropertyDescriptor(_class.prototype, "validateFlashType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dynamicElement", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "dynamicElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeyboardVisibilityChange", [bind], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyboardVisibilityChange"), _class.prototype)), _class);
function _animateBackdropOpacity(position1) {
  const backdrop1 = this.wrapperElement.nextElementSibling;
  if (!backdrop1) {
    return;
  }
  const opacity1 = 1 - position1 / this.modalContainer.clientHeight;
  backdrop1.animate([{
    opacity: Math.max(0, Math.min(opacity1, 0.6))
  }], {
    fill: "forwards"
  });
}
async function _animateWrapperPosition(position1) {
  _assertClassBrand(_DModal_brand, this, _animateBackdropOpacity).call(this, position1);
  await this.modalContainer.animate([{
    transform: `translateY(${position1}px)`
  }], {
    fill: "forwards",
    duration: getMaxAnimationTimeMs()
  }).finished;
}
export { DModal as default };